// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import ISimpleReference from "../core/ISimpleReference";

export const DifficultyList: ISimpleReference[] = [
  { id: "peaceful" },
  { id: "easy" },
  { id: "normal" },
  { id: "hard" },
];
